import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { HorizontalRuleIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { FocusPlugin } from '../plugins/FocusPlugin';
import { jsx as _jsx } from "react/jsx-runtime";
export const insertHorizontalRuleCommand = (state, dispatch) => {
  // Not handling replace behavior (where selection is a non-zero range) and
  // preventing inserting hr in nested blocks like lists and blockquotes
  if (state.selection.from !== state.selection.to || state.selection.$from.depth > 1) {
    return false;
  }
  if (dispatch) {
    const insertHrAndFocus = state.tr.insert(state.selection.$from.before(), state.schema.nodes.horizontal_rule.create()).setMeta(FocusPlugin, {
      focusView: true,
      focusViewPos: state.selection.from
    });
    dispatch(insertHrAndFocus);
  }
  return true;
};
export default function InsertHorizontalRule() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const disabled = useMemo(() => !insertHorizontalRuleCommand(editorState), [editorState]);
  const insertHorizonalRule = useCallback(e => {
    e.preventDefault();
    insertHorizontalRuleCommand(editorState, tr => setEditorState(editorState.apply(tr)));
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.insertHorizontalRule"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      "data-test-id": "horizontalRule",
      onClick: insertHorizonalRule,
      disabled: disabled,
      selected: false,
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: HorizontalRuleIcon,
        disabled: disabled
      })
    })
  });
}